<template>
  <div v-if="showBanner" class="cookie-banner">
    <div class="cookie-banner__content">
      <div class="cookie-banner__description">
        <p>
          We use cookies and similar technologies to run our site, analyse site
          traffic, personalise content and serve targeted ads. Find out more in
          our
          <a
            target="_blank"
            href="https://www.percayso-inform.com/privacy-policy/"
            >privacy policy</a
          >. You can manage your cookie choices at any time in the Cookie
          settings.
        </p>
        <p>
          If you decline, your information will not be tracked when you visit
          this website. A single cookie will be used in your browser to be
          tracked.
        </p>
      </div>
      <div class="cookie-banner__actions">
        <div class="cookie-banner__button-group">
          <button class="button is-primary" @click="acceptCookies">
            Accept All
          </button>
          <button class="button is-outline" @click="rejectCookies">
            Reject All
          </button>
          <button class="button is-text" @click="settingsCookies">
            Settings
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'CookieBanner',
  computed: {
    ...mapGetters('cookies', ['showBanner'])
  },
  methods: {
    ...mapActions('cookies', [
      'acceptAll',
      'rejectAll',
      'hideBanner',
      'loadFromStorage'
    ]),

    acceptCookies() {
      this.acceptAll()
      this.hideBanner()
    },

    rejectCookies() {
      this.rejectAll()
      this.hideBanner()
    },

    settingsCookies() {
      this.$modal.open('cookies/CookieSettings')
      this.hideBanner()
    }
  },

  mounted() {
    this.loadFromStorage()
  }
}
</script>

<style scoped>
.cookie-banner__content {
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
}

.cookie-banner__description {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin: 2rem auto;
}

.cookie-banner__actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-right: 1rem;
}

@media (max-width: 768px) {
  .cookie-banner__actions {
    justify-content: center;
    margin-right: 0;
  }
}

.cookie-banner {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  background: #fff;
  color: #1e3a8a;
  display: flex;
  flex-direction: column;
  z-index: 99999;
  -webkit-box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.1);
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.1);
  padding: 2rem;
}

.button {
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.2s;
  font-family: 'greycliff-cf', 'Poppins', sans-serif;
}

.button.is-primary {
  background: #1e3a8a;
  color: #fff;
}

.button.is-primary:hover {
  background: #1e40af;
}

.button.is-outline {
  background: transparent;
  color: #1e3a8a;
  border: 2px solid #1e3a8a;
}

.button.is-outline:hover {
  background: #1e3a8a;
  color: #fff;
}

.button.is-text {
  background: transparent;
  color: #1e3a8a;
  border: none;
  padding: 10px 20px;
}

.button.is-text:hover {
  background: rgba(30, 58, 138, 0.1);
}

.cookie-banner__button-group {
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
  align-items: center;
  font-family: 'greycliff-cf', 'Poppins', sans-serif;
}

@media (max-width: 768px) {
  .cookie-banner__button-group {
    justify-content: center;
  }
}
</style>
